import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import api from '../api';

function clp(n) {
  return `$${Number(n || 0).toLocaleString('es-CL')}`;
}

function todayIso() {
  return new Date().toISOString().slice(0, 10);
}

export default function EgresosPage() {
  const { cid } = useParams();
  const [egresos, setEgresos] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [form, setForm] = useState({
    categoriaId: '',
    descripcion: '',
    importe: '',
    fechaDocumento: todayIso(),
    fechaPago: todayIso(),
    marcarPagado: true,
    nuevaCategoria: ''
  });
  const [error, setError] = useState('');
  const [msg, setMsg] = useState('');

  const load = () => {
    api.get(`/gastos-comunes/condominios/${cid}/egresos`).then((r) =>
      setEgresos(r.data.map((e) => ({ ...e, id: e.id || e._id })))
    );
    api
      .get(`/gastos-comunes/condominios/${cid}/egresos/categorias`)
      .then((r) => {
        const rows = r.data.map((c) => ({ ...c, id: c.id || c._id }));
        setCategorias(rows);
        if (!form.categoriaId && rows[0]) setForm((f) => ({ ...f, categoriaId: rows[0].id }));
      })
      .catch((e) => setError(e.response?.data?.error || e.message));
  };

  useEffect(() => {
    if (cid) {
      localStorage.setItem('gc_condominio_id', cid);
      load();
    }
  }, [cid]);

  const agregarCategoria = async () => {
    if (!form.nuevaCategoria.trim()) return;
    setError('');
    try {
      const { data } = await api.post(`/gastos-comunes/condominios/${cid}/egresos/categorias`, {
        nombre: form.nuevaCategoria.trim()
      });
      setForm((f) => ({ ...f, nuevaCategoria: '', categoriaId: data.id }));
      load();
    } catch (err) {
      setError(err.response?.data?.error || err.message);
    }
  };

  const crear = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await api.post(`/gastos-comunes/condominios/${cid}/egresos`, {
        categoriaId: form.categoriaId,
        descripcion: form.descripcion,
        importe: Number(form.importe),
        fechaDocumento: form.fechaDocumento,
        marcarPagado: form.marcarPagado,
        fechaPago: form.marcarPagado ? form.fechaPago : undefined
      });
      setForm({ ...form, descripcion: '', importe: '' });
      setMsg(form.marcarPagado ? 'Gasto registrado y pagado (salida de caja).' : 'Gasto guardado pendiente.');
      load();
    } catch (err) {
      setError(err.response?.data?.error || err.message);
    }
  };

  const marcarPagado = async (id) => {
    setError('');
    try {
      await api.post(`/gastos-comunes/condominios/${cid}/egresos/${id}/marcar-pagado`, {
        fechaPago: new Date().toISOString()
      });
      load();
    } catch (err) {
      setError(err.response?.data?.error || err.message);
    }
  };

  return (
    <>
      <h1 className="page-title">Egresos</h1>
      <p className="page-lead">Gastos del condominio con categoría y fechas.</p>
      {error && <div className="alert alert-error">{error}</div>}
      {msg && <div className="alert alert-success">{msg}</div>}

      <div className="card">
        <h3 className="card-title-sm">Registrar gasto</h3>
        <form onSubmit={crear}>
          <div className="form-row">
            <div className="field">
              <label>Categoría</label>
              <select value={form.categoriaId} onChange={(e) => setForm({ ...form, categoriaId: e.target.value })} required>
                {categorias.map((c) => (
                  <option key={c.id} value={c.id}>
                    {c.nombre}
                  </option>
                ))}
              </select>
            </div>
            <div className="field field-grow">
              <label>Nueva categoría</label>
              <div className="inline-add">
                <input
                  value={form.nuevaCategoria}
                  onChange={(e) => setForm({ ...form, nuevaCategoria: e.target.value })}
                  placeholder="Ej. Agua potable"
                />
                <button type="button" className="btn secondary" onClick={agregarCategoria}>
                  +
                </button>
              </div>
            </div>
          </div>
          <div className="form-row">
            <div className="field field-grow">
              <label>Descripción</label>
              <input value={form.descripcion} onChange={(e) => setForm({ ...form, descripcion: e.target.value })} required />
            </div>
            <div className="field">
              <label>Importe CLP</label>
              <input type="number" min="1" value={form.importe} onChange={(e) => setForm({ ...form, importe: e.target.value })} required />
            </div>
          </div>
          <div className="form-row">
            <div className="field">
              <label>Fecha documento</label>
              <input type="date" value={form.fechaDocumento} onChange={(e) => setForm({ ...form, fechaDocumento: e.target.value })} />
            </div>
            <div className="field">
              <label>Fecha pago</label>
              <input
                type="date"
                value={form.fechaPago}
                onChange={(e) => setForm({ ...form, fechaPago: e.target.value })}
                disabled={!form.marcarPagado}
              />
            </div>
            <div className="field field-check">
              <label>
                <input
                  type="checkbox"
                  checked={form.marcarPagado}
                  onChange={(e) => setForm({ ...form, marcarPagado: e.target.checked })}
                />
                Ya pagado (descuenta caja)
              </label>
            </div>
          </div>
          <button type="submit" className="btn">
            Guardar
          </button>
        </form>
      </div>

      <div className="card card-flat">
        <div className="table-wrap">
          <table className="data-table">
            <thead>
              <tr>
                <th>Fecha doc.</th>
                <th>Descripción</th>
                <th>Importe</th>
                <th>Estado</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {egresos.map((e) => (
                <tr key={e.id}>
                  <td>{e.fechaDocumento ? new Date(e.fechaDocumento).toLocaleDateString('es-CL') : '—'}</td>
                  <td>{e.descripcion}</td>
                  <td>{clp(e.importe)}</td>
                  <td>{e.estado}</td>
                  <td>
                    {e.estado === 'pendiente' && (
                      <button type="button" className="btn secondary btn-sm" onClick={() => marcarPagado(e.id)}>
                        Pagado
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}
